var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsLowcreditActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 20.375 20.395",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_28._Saving",
    "data-name": "28. Saving",
    transform: "translate(0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2596",
    "data-name": "Path 2596",
    d: "M20.052,16.807a3.186,3.186,0,0,0-4.161.554l-2.039,2.326a2.549,2.549,0,0,0-2.383-1.676h-.593a1.619,1.619,0,0,1-.9-.274,5.977,5.977,0,0,0-7.532.746L.183,20.745a.64.64,0,1,0,.9.9L3.35,19.387A4.684,4.684,0,0,1,9.27,18.8a2.88,2.88,0,0,0,1.606.484h.593a1.274,1.274,0,0,1,1.274,1.274H8.282a.637.637,0,1,0,0,1.274h5.1a.637.637,0,0,0,.472-.223h0L16.84,18.2a1.912,1.912,0,0,1,1.912-.586l-4.48,6.009a1.912,1.912,0,0,1-1.529.765H7.269a2.8,2.8,0,0,0-1.988.822.64.64,0,1,0,.9.9,1.51,1.51,0,0,1,1.083-.452h5.474a3.186,3.186,0,0,0,2.549-1.274l4.97-6.627a.7.7,0,0,0,.1-.51A.739.739,0,0,0,20.052,16.807Z",
    transform: "translate(0 -5.904)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2597",
    "data-name": "Path 2597",
    d: "M17.1,10.2A5.1,5.1,0,1,0,12,5.1,5.1,5.1,0,0,0,17.1,10.2Zm0-8.921A3.823,3.823,0,1,1,13.274,5.1,3.823,3.823,0,0,1,17.1,1.274Z",
    transform: "translate(-4.355)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2598",
    "data-name": "Path 2598",
    d: "M18.156,8.864a.637.637,0,0,0,.9,0l1.8-1.8a.637.637,0,0,0,0-.9l-1.8-1.8a.637.637,0,0,0-.9,0l-1.8,1.8a.637.637,0,0,0,0,.9Zm.452-3.154.9.9-.9.9-.9-.9Z",
    transform: "translate(-5.866 -1.511)",
    fill: "#1450ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2599",
    "data-name": "Path 2599",
    d: "M4.637,3.549h.637v.637a.637.637,0,0,0,1.274,0V3.549h.637a.637.637,0,0,0,0-1.274H6.549V1.637a.637.637,0,1,0-1.274,0v.637H4.637a.637.637,0,0,0,0,1.274Z",
    transform: "translate(-1.453 -0.363)",
    fill: "#1450ff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsLowcreditActiveIcon);
export default __webpack_public_path__ + "static/media/settings-lowcredit-active-icon.a7cd4b7626ff4b5db9093b38c7a05e72.svg";
export { ForwardRef as ReactComponent };